// extracted by mini-css-extract-plugin
export default {"iconWrap":"CardIcon_iconWrap__PhHox"};